// Material UI
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";

import states from "../../../Utilities/States";
import brands from "../../../Utilities/Brands";

const OptOutSearchForm = (
  reportToken,
  setReportToken,
  brandId,
  setBrandId,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  city,
  setCity,
  state,
  setState,
  minAge,
  setMinAge,
  maxAge,
  setMaxAge
) => {

  const allStates = [...[{ id: "all", name: "All States" }], ...states];

  const formLabels = [
    {
      Label: "Report Token",
      Element: "TextField",
      Value: reportToken,
      Setter: setReportToken,
    },
    {
      Label: "Brand",
      Element: "FormControl",
      Value: brandId,
      Setter: setBrandId,
      Data:
      <>
      <option value="" key="-1" />
        {brands.map((card, _idx) => {
          return (
            <option key={card._id} value={card._id}>
              {card.brand}
            </option>
          );
        })}
      </>
    },
    {
      Label: "First Name",
      Element: "TextField",
      Value: firstName,
      Setter: setFirstName,
    },
    {
      Label: "Last Name",
      Element: "TextField",
      Value: lastName,
      Setter: setLastName,
    },
    {
      Label: "City",
      Element: "TextField",
      Value: city,
      Setter: setCity,
    },
    {
      Label: "State",
      Element: "FormControl",
      Value: state,
      Setter: setState,
      Data: 
      <>
        <option value="" />
        {allStates.map((state, idx) => (  
          <option key={idx} value={state.id}>
            {state.name}
          </option>            
        ))}
      </>
    },
    {
      Label: "Min Age",
      Element: "TextField",
      Value: minAge,
      Setter: setMinAge,
    },
    {
      Label: "Max Age",
      Element: "TextField",
      Value: maxAge,
      Setter: setMaxAge,
    },
  ];

  return formLabels.map(
    ({ Label, Element, Type, Data, Value, Setter }, idx) => {
      switch (Element) {
        case "TextField":
          return (
            <TextField
              key={idx}
              id="outlined-full-width"
              className="input-el"
              label={Label}
              type={Type}
              style={{ margin: 8, width: "14rem" }}
              fullWidth={false}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            />
          );
        case "FormControl":
          return (
            <FormControl
              key={idx}
              variant="outlined"
              style={{ margin: 8, width: "14rem" }}
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            >
              <InputLabel htmlFor="outlined-age-native-simple">
                {Label}
              </InputLabel>
              <Select
                native={true}
                label={Label}
                value={Value}
                inputProps={{
                  name: `${Label.toLowerCase()}`,
                  id: `outlined-${Label.toLowerCase()}-native-simple`,
                }}
              >
                {Data}
              </Select>
            </FormControl>
          );
        default:
          return null;
      }
    }
  );
};

export default OptOutSearchForm;
